<template>
  <table class="w-full" v-if="data && data.length > 0">
    <!-- header -->
    <tr class="border-b border-light-gray py-1">
      <th class="p-2 text-left" v-for="(item, index) in headers" :key="index">
        {{ item }}
      </th>
      <th v-if="buttonsAvailable"></th>
    </tr>

    <tr
      class="border-b border-light-gray py-1"
      v-for="(row, rIndex) in data"
      :key="rIndex"
    >
      <td class="p-2 text-sm" v-for="(col, cIndex) in allowedColumns(row)" :key="cIndex">
        {{ col }}
      </td>
      <td class="p-2 text-right" v-if="buttonsAvailable">
        <slot v-bind:row="row" name="buttons"></slot>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "TableComponent",
  props: {
    headers: {
      required: true,
      type: Array,
    },
    keys: {
      required: false,
      type: Array,
      
    },
    data: {
      required: true,
      type: Array
    },
    colWidths: {
      required: false,
      type: Array
    },
  },
  computed: {
    buttonsAvailable() {
      return this.$scopedSlots.buttons ?? false;
    }
  },

  methods: {
    allowedColumns(row) {
      let newRow = {};
      for(var a in this.keys) {
        if(row[ this.keys[a] ] !== undefined) {
          newRow[ this.keys[a] ] = row[ this.keys[a] ];
        }
      }
      return newRow;
    }
  }
};
</script>

<style></style>
